import { cssVar } from "@chakra-ui/theme-tools";

const $size = cssVar("spinner-size");

const baseStyle = {
  width: [$size.reference],
  height: [$size.reference]
};

const sizes = {
  sm: {
    [$size.variable]: "20px"
  },
  md: {
    [$size.variable]: "24px"
  },
  lg: {
    [$size.variable]: "32px"
  },
  xl: {
    [$size.variable]: "42px"
  }
};

const baseVariant = {
  borderWidth: "3px",
  animationDuration: "0.6s",
  color: "primary"
};

const variants = {
  base: baseVariant
};

const defaultProps = {
  size: "md",
  variant: "base"
};

export default {
  baseStyle,
  sizes,
  defaultProps,
  variants
};
